import { configureStore } from "@reduxjs/toolkit";
import globalSnackbarSlice from "../features/snackbar/globalSnackbarSlice";
import messgeraeteSlice from "../routes/administration/messgeraete/messgeraeteSlice";
import routergeraetSlice from "../routes/administration/routergeraet/routergeraetSlice";
import messstellenSlice from "../routes/administration/messstellen/messstellenSlice";
import geraeteManagementSlice from "../routes/geraetemanagement/geraeteManagementSlice";
import netzwirtschaftSlice from "../routes/netzwirtschaft/netzwirtschaftSlice";
import messstellenLookupSlice from "../features/messstellenLookup/messstellenLookupSlice";
import gruppenverwaltungSlice from "../routes/pqereignisse/gruppenverwaltung/gruppenverwaltungSlice";
import pqEreignisseSlice from "../routes/pqereignisse/pqEreignisseSlice";
import netzereignisseSlice from "../routes/administration/netzereignisse/netzereignisseSlice";
import wertelisteSlice from "../routes/administration/werteliste/wertelisteSlice";
import messgereattypenSlice from "../routes/administration/werteliste/messgeraettypen/messgeraettypenSlice";
import routergereattypenSlice from "../routes/administration/werteliste/routergeraettypen/routergeraettypenSlice";
import schaltfelderSlice from "../routes/administration/werteliste/schaltfelder/schaltfelderSlice";
import umspannwerkeSlice from "../routes/administration/werteliste/umspannwerke/umspannwerkeSlice";
import spannungsebenenSlice from "../routes/administration/werteliste/spannungsebenen/spannungsebenenSlice";
import spannungswandlerSlice from "../routes/administration/werteliste/spannungswandler/spannungswandlerSlice";
import wandlerSlice from "../routes/administration/werteliste/wandler/wandlerSlice";
import wartungsintervallSlice from "../routes/administration/werteliste/wartungsintervall/wartungsintervallSlice";
import zeitsynchronisationsartSlice from "../routes/administration/werteliste/zeitsynchronisationsart/zeitsynchronisationsartSlice";
import anlagenSlice from "../routes/administration/werteliste/anlagen/anlagenSlice";
import gruppenSlice from "../routes/pqereignisse/gruppen/gruppenSlice";
import betriebsereignisseSlice from "../routes/betriebsereignisse/betriebsereignisseSlice";
import stoerungsmanagementSlice from "../routes/stoerungsmanagement/stoerungsmanagementSlice";
import konfigurationSlice from "../features/konfiguration/konfigurationSlice";
import datenflussSlice from "../routes/datenfluss/datenflussSlice";
import datenvollstaendigkeitSlice from "../routes/datenvollstaendigkeit/datenvollstaendigkeitSlice";
import datenplausibilitaetSlice from "../routes/datenplausibilitaet/datenplausibilitaetSlice";
import zeitSlice from "../features/filter/zeitSlice";
import messstellenFilterSlice from "../features/filter/messstellenFilterSlice";
import kenngroesseSlice from "../features/filter/kenngroesseSlice";
import PqIndexSlice from "../routes/analyse/pqIndex/pqIndexSlice";
import korrelationFilterSlice from "../routes/analyse/korrelation/korrelationFilterSlice";
import korrelationSlice from "../routes/analyse/korrelation/korrelationSlice";
import uwZeitTableSlice from "../routes/analyse/pqIndex/uwZeitTableSlice";
import uwKenngroesseGruppeTableSlice from "../routes/analyse/pqIndex/uwKenngroesseGruppeTableSlice";
import kenngroesseGruppeZeitTableSlice from "../routes/analyse/pqIndex/kenngroesseGruppeZeitTableSlice";
import kenngroesseDetailTableSlice from "../routes/analyse/pqIndex/kenngroesseDetailTableSlice";
import messstelleTableSlice from "../routes/analyse/pqIndex/messstelleTableSlice";
import lambdacontrolSlice from "../routes/administration/lambdacontrol/lambdacontrolSlice";
import anomalieSlice from "../routes/analyse/anomalie/anomalieSlice";
import anomalieFilterSlice from "../routes/analyse/anomalie/anomalieFilterSlice";
import anomalieGeneralGridSlice from "../routes/analyse/anomalie/anomalieGeneralGridSlice";
import anomalieDetailedGridSlice from "../routes/analyse/anomalie/anomalieDetailedGridSlice";
import globalDialogSlice from "../features/globalDialog/globalDialogSlice";
import trendsFilterSlice from "../routes/analyse/trends/trendsFilterSlice";
import trendsSlice from "../routes/analyse/trends/trendsSlice";
import trendsTableSlice from "../routes/analyse/trends/trendsTableSlice";
import trendsCellMenuSlice from "../routes/analyse/trends/trendsCellMenuSlice";
import datenabrufSlice from "../routes/administration/datenabruf/datenabrufSlice";
import firewallantragSlice from "../routes/administration/firewallantrag/firewallantragSlice";
import ipVerwaltungSlice from "../routes/administration/ipVerwaltung/ipVerwaltungSlice";

export const store = configureStore({
  reducer: {
    netzwirtschaft: netzwirtschaftSlice,
    messstellenLookup: messstellenLookupSlice,
    messstelle: messstellenSlice,
    messgeraete: messgeraeteSlice,
    werteliste: wertelisteSlice,
    messgeraettyp: messgereattypenSlice,
    routergeraettyp: routergereattypenSlice,
    schaltfeld: schaltfelderSlice,
    umspannwerk: umspannwerkeSlice,
    spannungsebene: spannungsebenenSlice,
    spannungswandler: spannungswandlerSlice,
    wandler: wandlerSlice,
    wartungsintervall: wartungsintervallSlice,
    zeitsynchronisationsart: zeitsynchronisationsartSlice,
    anlage: anlagenSlice,
    routergeraet: routergeraetSlice,
    snackbar: globalSnackbarSlice,
    konfiguration: konfigurationSlice,
    geraeteManagement: geraeteManagementSlice,
    gruppenverwaltung: gruppenverwaltungSlice,
    pqereignisse: pqEreignisseSlice,
    netzereignisse: netzereignisseSlice,
    gruppen: gruppenSlice,
    betriebsereignisse: betriebsereignisseSlice,
    stoerungsmanagement: stoerungsmanagementSlice,
    datenfluss: datenflussSlice,
    datenvollstaendigkeit: datenvollstaendigkeitSlice,
    datenplausibilitaet: datenplausibilitaetSlice,
    zeit: zeitSlice,
    messstellenFilter: messstellenFilterSlice,
    kenngroesseFilter: kenngroesseSlice,
    pqIndex: PqIndexSlice,
    korrelationFilter: korrelationFilterSlice,
    korrelation: korrelationSlice,
    uwZeitPqIndex: uwZeitTableSlice,
    kenngroesseGruppeUwPqIndex: uwKenngroesseGruppeTableSlice,
    kenngroesseGruppeZeitPqIndex: kenngroesseGruppeZeitTableSlice,
    kenngroesseDetailPqIndex: kenngroesseDetailTableSlice,
    messstellePqIndex: messstelleTableSlice,
    lambdacontrol: lambdacontrolSlice,
    anomalie: anomalieSlice,
    anomalieFilter: anomalieFilterSlice,
    anomalieGeneralGrid: anomalieGeneralGridSlice,
    anomalieDetailedGrid: anomalieDetailedGridSlice,
    trendsFilter: trendsFilterSlice,
    trendsTable: trendsTableSlice,
    trends: trendsSlice,
    trendsCellMenu: trendsCellMenuSlice,
    dialog: globalDialogSlice,
    datenabruf: datenabrufSlice,
    firewallantrag: firewallantragSlice,
    ipVerwaltung: ipVerwaltungSlice,
  },
});
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
